import React, { useEffect, useState } from "react";
import {
  HashRouter,
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";

const data = {
  teams: {
    1: { name: "Steelers", city: "Pittsburgh" },
    2: { name: "Eagles", city: "Philadelphia" },
    3: { name: "Ravens", city: "Baltimore" },
  },
  players: {
    101: { name: "John Smith", position: "Setter" },
    102: { name: "Mike Jones", position: "Outside" },
    103: { name: "Tom Brown", position: "Libero" },
  },
  matches: {
    201: { opponent: "Central", score: "3-1" },
    202: { opponent: "North", score: "3-2" },
    203: { opponent: "South", score: "0-3" },
  },
};

function Apper() {
  return (
    <HashRouter>
      <Routes>
        <Route path="*" element={<Page />} />
      </Routes>
    </HashRouter>
  );
}

/*
 * This is the important component.
 *
 * There is ONLY ONE Page component mounted.
 * The URL changes, but Page remains mounted.
 */
function Page() {
  const location = useLocation();
  const navigate = useNavigate();

  const [count, setCount] = useState(0);

  useEffect(() => {
    console.log("🟢 Page MOUNT");
    return () => {
      console.log("🔴 Page UNMOUNT");
    };
  }, []);

  console.log("🔄 Page RENDER", location.pathname);

  const parts = location.pathname
    .split("/")
    .filter(Boolean);

  const level = parts.length;

  let content;

  switch (level) {
    case 0:
      content = <Home />;
      break;

    case 1:
      content = <Team id={parts[0]} />;
      break;

    case 2:
      content = (
        <Player
          teamId={parts[0]}
          playerId={parts[1]}
        />
      );
      break;

    case 3:
      content = (
        <Match
          teamId={parts[0]}
          playerId={parts[1]}
          matchId={parts[2]}
        />
      );
      break;

    default:
      content = <div>Too deep!</div>;
  }

  return (
    <div style={{ padding: 20, backgroundColor: 'grey' }}>
      <h1>Persistent Page Wrapper</h1>

      <div>
        <strong>URL:</strong> {location.pathname}
      </div>

      <div>
        <strong>Level:</strong> {level}
      </div>

      <hr />

      <button onClick={() => setCount(c => c + 1)}>
        Wrapper Count: {count}
      </button>

      <button
        onClick={() => navigate(-1)}
        style={{ marginLeft: 10 }}
      >
        Back
      </button>

      <hr />

      {content}
    </div>
  );
}

function Home() {

  const navigate = useNavigate();
  const handleNav = (path) => navigate(path);

  return (
    <div>
      <h2>Home</h2>

      <div onClick={() => { handleNav("/1") }}>
        Go to Steelers
      </div>

      {/* <Link to="/1">
        Go to Steelers
      </Link> */}
    </div>
  );
}

function Team({ id }) {

  const navigate = useNavigate();
  const handleNav = (path) => navigate(path);

  const team = data.teams[id];

  return (
    <div>
      <h2>Team</h2>

      <p>
        {team?.name} — {team?.city}
      </p>

      <div onClick={() => { handleNav(`/${id}/101`) }}>
        View John Smith
      </div>
      {/* <Link to={`/${id}/101`}>
        View John Smith
      </Link> */}
    </div>
  );
}

function Player({ teamId, playerId }) {
  const player = data.players[playerId];

  const navigate = useNavigate();
  const handleNav = (path) => navigate(path);

  return (
    <div>
      <h2>Player</h2>

      <p>
        {player?.name} — {player?.position}
      </p>

      <div onClick={() => { handleNav(`/${teamId}/${playerId}/201`) }}>
        View Match
      </div>

      {/* <Link to={`/${teamId}/${playerId}/201`}>
        View Match
      </Link> */}
    </div>
  );
}

function Match({ teamId, playerId, matchId }) {
  const match = data.matches[matchId];

  return (
    <div>
      <h2>Match</h2>

      <p>
        vs {match?.opponent}
      </p>

      <p>
        Score: {match?.score}
      </p>

      <Link to={`/${teamId}/${playerId}`}>
        Back to Player
      </Link>
    </div>
  );
}

export default Apper;

